import React, { memo } from 'react';
import { Circle } from '@react-google-maps/api';

const MapCircle = memo((props) => {
    return <Circle {...props} />;
});

export default MapCircle;
